import React from "react";
import { stopImpersonating } from "../../store/actions/auth.action";

const ImpersonationBanner = () => {
  const originalToken = localStorage.getItem("admin_original_token");
  const currentUserMail = localStorage.getItem("mail");
  const adminMail = localStorage.getItem("admin_original_mail");

  if (!originalToken) return null;

  return (
    <div className="bg-amber-500 text-white font-medium text-sm py-2 px-6 flex items-center justify-between shadow-md z-[9999] relative">
      <div className="flex items-center gap-2">
        <span className="text-base">⚠️</span>
        <span>
          <strong>Admin Impersonation Active:</strong> Logged in as <u>{currentUserMail}</u> (Admin: {adminMail})
        </span>
      </div>
      <button
        onClick={() => stopImpersonating()()}
        className="bg-white text-amber-900 font-bold px-3 py-1 rounded-full text-xs hover:bg-amber-100 transition-colors shadow-sm cursor-pointer"
      >
        Exit Impersonation Mode
      </button>
    </div>
  );
};

export default ImpersonationBanner;
